// S3 serves the root build's index.html for every key it doesn't have, so a reload on a PR preview's deep
// link (/pr/<branch>/organizations/42) lands on the root build. The root build sends it to the preview's own
// index.html with the route in PREVIEW_PATH_PARAM, and the preview puts the route back before its router starts.
export const PREVIEW_PATH_PARAM = 'preview_path';
const PREVIEW_ROUTE = /^\/pr\/([^/]+)\/(.+)$/;

// Where the root build should send this location, or null when it is not a preview's deep link.
export function previewRedirect(location, basename) {
    if (basename && basename !== '/') return null;
    const match = location.pathname.match(PREVIEW_ROUTE);
    if (!match || match[2] === 'index.html') return null;
    const params = new URLSearchParams({ [PREVIEW_PATH_PARAM]: `/${match[2]}${location.search}` });
    return `/pr/${match[1]}/index.html?${params}${location.hash}`;
}

// The URL the preview should show instead of its index.html, or null when there is no route to restore.
export function restoredPreviewUrl(location, basename) {
    const route = new URLSearchParams(location.search).get(PREVIEW_PATH_PARAM);
    // Only a path on this site: never a protocol-relative URL or anything else a link could smuggle in.
    if (!route || !route.startsWith('/') || route.startsWith('//')) return null;
    return `${basename.replace(/\/$/, '')}${route}${location.hash}`;
}

export function followPreviewDeepLink(win, basename) {
    const redirect = previewRedirect(win.location, basename);
    if (redirect) {
        win.location.replace(redirect);
        return;
    }
    const restored = restoredPreviewUrl(win.location, basename);
    if (restored) {
        win.history.replaceState(win.history.state, '', restored);
    }
}

// The branch a PR preview build was made from, or null on the root build.
export function consolePreviewName(basename) {
    const match = (basename || '').match(/^\/pr\/([^/]+)\/?$/);
    return match ? match[1] : null;
}

// The same page on the root build.
export function outsidePreview(location, basename) {
    const prefix = basename.replace(/\/$/, '');
    const route = location.pathname.startsWith(prefix) ? location.pathname.slice(prefix.length) : location.pathname;
    return `${route || '/'}${location.search}${location.hash}`;
}
